<template>
    <btn-builder :config="BTN_CONFIG" :row="row" :model="model" @del="$emit('del')"></btn-builder>
</template>

<script>
import BTN_CONFIG from '../config/btns-list'

export default {
    components: { },
    props: {
        row: {
           type: Object,
           default: () => ({})
       },
       model: {
           type: Object,
           default: () => ({})
       },
       config: {
           type: Array,
           default: () => []
       }
    },
    data: () => ({
        BTN_CONFIG
    }),
    computed: {

    },
    methods: {

    }
}
</script>

<style>

</style>
